export default __webpack_public_path__ + "static/media/476.9d7c1244.png";